import { Alert, Anchor, Badge, Center, Group, Image, Loader, Stack, Text, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { newsApi } from '../api/studio';
import { ru } from '../i18n/ru';
import { formatDate } from '../studio/format';
import { accentText } from '../theme';

export function NewsDetailPage() {
  const { slug = '' } = useParams();

  const post = useQuery({
    queryKey: ['news', slug],
    queryFn: () => newsApi.bySlug(slug),
    retry: false,
  });

  if (post.isPending) {
    return (
      <Center h={200}>
        <Loader />
      </Center>
    );
  }

  if (post.isError || post.data === undefined) {
    return (
      <Stack gap="md" maw={560}>
        <Alert color="gray" variant="light">
          {ru.news.notFound}
        </Alert>
        <Anchor component={Link} to="/news" c={accentText}>
          {ru.news.backToFeed}
        </Anchor>
      </Stack>
    );
  }

  const news = post.data;

  return (
    <Stack gap="lg" maw={760}>
      <Anchor component={Link} to="/news" size="sm" c={accentText}>
        {ru.news.backToFeed}
      </Anchor>

      <Stack gap="xs">
        <Group gap="xs">
          {news.publishedAt !== null && (
            <Text size="sm" c="graphite.5">
              {formatDate(news.publishedAt)}
            </Text>
          )}
          {!news.isPublished && (
            <Badge color="gray" variant="light">
              {ru.news.draft}
            </Badge>
          )}
          {!news.forAllGroups &&
            news.groupNames.map((name) => (
              <Badge key={name} size="sm" variant="light">
                {name}
              </Badge>
            ))}
        </Group>

        {/* У короткого объявления заголовка нет — текст начинается сразу. */}
        {news.title !== null && (
          <Title order={1} fz={{ base: 24, sm: 30 }} c="graphite.9">
            {news.title}
          </Title>
        )}
      </Stack>

      {news.coverImageUrl !== null && (
        <Image src={news.coverImageUrl} radius="md" alt="" />
      )}

      {/*
        Разметку чистит сервер белым списком тегов при сохранении: только так
        она безопасна, потому что запрос может прийти и мимо интерфейса.
      */}
      <div className="news-body" dangerouslySetInnerHTML={{ __html: news.bodyHtml }} />

      <Text size="xs" c="graphite.5">
        {ru.news.author}: {news.authorName}
      </Text>
    </Stack>
  );
}
